import { render, staticRenderFns } from "./MenuReporteMateria.vue?vue&type=template&id=5563fb70"
import script from "./MenuReporteMateria.vue?vue&type=script&lang=js"
export * from "./MenuReporteMateria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports